export default __webpack_public_path__ + "static/media/ETH.9270fc02.svg";